import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { IonContent, IonHeader, IonItem, IonLabel, IonText, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { ModalController } from '@ionic/angular/standalone';
import { Store } from "@ngrx/store";
import { DisplayService } from '@qid/core';
import { SexyModule } from '@qid/sexy';
import { AvatarRoundComponent, SuperInputModalComponent } from '@qid/super';
import { firstValueFrom, Observable } from 'rxjs';
import { FormatPhonePipe } from '../../../../../pipes/format-phone.pipe';
import { EmailUpdateComponent, MobileUpdateComponent, UserService, UsersFacade, UsersSelectors } from "../../../index";
import { User } from '../../model/User';
@Component({
  selector: 'app-edit-organisation',
  templateUrl: './edit-user.page.html',
  styleUrls: ['./edit-user.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SexyModule,
    AvatarRoundComponent,
    FormatPhonePipe,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonItem,
    IonLabel,
    IonText
  ]
})
export class EditUserPage implements OnInit {
  public user$: Observable<User> = this.store.select(UsersSelectors.selectAuthenticatedUser)

  constructor(
    private userService: UserService,
    private modalController: ModalController,
    private displayService: DisplayService,
    private usersFacade: UsersFacade,
    private store: Store
  ) {
  }

  ngOnInit() {
  }
  uploadUserDisplayPic = async (file: any) => {
    await this.userService.updateDisplayPic(
      file.file
    );
  };

  async saveUser(key: string) {
    let user = await firstValueFrom(this.user$)
    await this.updateWithModal(
      async value => {
        await this.usersFacade.updateUser({ ...user, [key]: value });
      },
      key,
      user[key]
    );
  }

  async updateMobile() {
    const modal = await this.modalController.create({
      component: MobileUpdateComponent,
      keyboardClose: false,
      animated: false,
    });
    await modal.present();
    await modal.onDidDismiss();
  }

  async updateEmail() {
    const model = await this.modalController.create({
      component: EmailUpdateComponent,
      keyboardClose: false,
      animated: false
    })

    await model.present();
    const res = await model.onDidDismiss()

    if (res.data && res.data.updated) {
      await this.displayService.alert("Email Updated!", "You are required to login again.")
    }
    await model.onDidDismiss();
  }

  async updateWithModal(callback, title: string, defaultVal = '') {
    const modal = await this.modalController.create({
      component: SuperInputModalComponent,
      componentProps: {
        title: title,
        action: callback,
        inputValue: defaultVal,
      },
      keyboardClose: false,
      animated: false,
    });
    await modal.present();
  }
}
